import React, { Component } from "react";
import "./style.css";
import "../../../index.css";
class ArticleLine extends Component {
  constructor(...props) {
    super(...props);
    this.state = {
      css: {
        articleLine_line: {
          width: 710,
          height: 1,
        },
      },
    };
  }
  componentDidMount() {
    this.fixCss();
    window.addEventListener("resize", () => {
      this.fixCss();
    });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this._resizeListener);
    clearTimeout(this.timeouter);
    this.setState = (state, callback) => {
      return;
    };
  }
  render() {
    const { visible } = this.props;
    return (
      <div
        style={this.state.css.articleLine_line}
        className={
          visible === true
            ? "articleLine_line"
            : "articleLine_line display_none"
        }
      ></div>
    );
  }
  fixCss = () => {
    let clientWidth = document.body.clientWidth;
    let ratio = 1;
    if (clientWidth < 750) {
      ratio = clientWidth / 750;
    }
    this.setState({
      css: {
        articleLine_line: {
          width: 710 * ratio,
          height: 1,
        },
      },
    });
  };
}

export default ArticleLine;



// WEBPACK FOOTER //
// ./src/components/Article/ArticleLine/index.js